var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibleEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89362 5.57031C9.48653 4.95677 10.1887 4.65 11 4.65C11.8113 4.65 12.5135 4.95677 13.1064 5.57031C13.6993 6.18385 13.9957 6.91042 13.9957 7.75C13.9957 8.58958 13.6993 9.31615 13.1064 9.92969C12.5135 10.5432 11.8113 10.85 11 10.85C10.1887 10.85 9.48653 10.5432 8.89362 9.92969C8.30071 9.31615 8.00426 8.58958 8.00426 7.75C8.00426 6.91042 8.30071 6.18385 8.89362 5.57031ZM7.44255 11.4312C8.44114 12.4323 9.62695 12.9328 11 12.9328C12.373 12.9328 13.5433 12.4323 14.5106 11.4312C15.5092 10.3979 16.0085 9.17083 16.0085 7.75C16.0085 6.32917 15.5092 5.11823 14.5106 4.11719C13.5433 3.08385 12.373 2.56719 11 2.56719C9.62695 2.56719 8.44114 3.08385 7.44255 4.11719C6.47518 5.11823 5.99149 6.32917 5.99149 7.75C5.99149 9.17083 6.47518 10.3979 7.44255 11.4312ZM4.30638 2.13125C6.30355 0.710417 8.53475 0 11 0C13.4652 0 15.6965 0.710417 17.6936 2.13125C19.6908 3.55208 21.1262 5.675 22 8C21.1262 10.325 19.6908 11.9479 17.6936 13.3687C15.6965 14.7896 13.4652 15.5 11 15.5C8.53475 15.5 6.30355 14.7896 4.30638 13.3687C2.30922 11.9479 0.873759 10.325 0 8C0.873759 5.675 2.30922 3.55208 4.30638 2.13125Z",
    fill: "#797A8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibleEye);
export default __webpack_public_path__ + "static/media/visible_eye.7fb4c900ad0b92b95a3f92dc04a45950.svg";
export { ForwardRef as ReactComponent };